import { iono } from 'global';
import { query as $, enableAttribute, scrollIntoView, resizeObserver, toggleHidden } from '../../utils/dom';
import Component from './component';
import iconNext from '../assets/icons/next.svg';
import iconPrevious from '../assets/icons/previous.svg';
import iconSpinner from '../../assets/icons/spinner.svg';
import iconFilter from '../assets/icons/filter.svg';
import { metadataSubTitle, metadataTitle } from '../utils/metadata';

export default class PlaylistComponent extends Component {
  constructor (props) {
    super(props);

    this.locale = this.props.locale;
    this.player = this.props.player;

    this.onresize = this.onresize.bind(this);
    this.onsearchinput = this.onsearchinput.bind(this);
    this.onactionclick = iono.Player.UI.Utils.Dom.delegate('[data-action]', this.onactionclick.bind(this));
    this.onitemclick = iono.Player.UI.Utils.Dom.delegate('.iono-playlist-item', this.onitemclick.bind(this));
    this.onplaylistload = this.onplaylistload.bind(this);
    this.onplaylistchange = this.onplaylistchange.bind(this);
    this.onplaylistselect = this.onplaylistselect.bind(this);
    this.onsearchfocus = this.onsearchfocus.bind(this);
  }

  getDefaultProps (props) {
    return {
      playlistIndex: -1,
      playlist: [],
      enableLoadMore: false,
      loading: false,
      term: ''
    };
  }

  loadMore () {
    this.props.player.loadMore();
  }

  onplaylistload (event) {
    this.props.loading = true;
    return this.updateLoadMore();
  }

  onplaylistchange (event) {
    this.props.enableLoadMore = this.props.player.canLoadMore();
    this.props.loading = false;
    if (event.loaded > 0) {
      return this.updatePlaylist(this.props.player.getPlaylist());
    } else if (event.added > 0) {
      return this.appendPlaylist(this.props.player.getPlaylist(), event.total - event.added);
    }
  }

  onplaylistselect (event) {
    this.updatePlaylistIndex(this.props.player.getPlaylistIndex());
  }

  onsearchinput (event) {
    this.filterPlaylist(event.target.value);
  }

  onsearchfocus (event) {
    event.preventDefault();
    this.$('.iono-playlist-search-input').focus();
  }

  onresize (event) {
    const width = event.detail.contentRect.width;

    if (this.$search) {
      toggleHidden(this.$search, width < 400);
    }
  }

  /**
   * Update the playlist
   *
   * @param {Array} playlist
   */
  updatePlaylist (playlist) {
    this.props.playlist = this.props.player.getPlaylist();
    this.props.playlistIndex = this.props.player.getPlaylistIndex();

    this.$('.iono-playlist-items').innerHTML = playlist.map((item, index) => {
      return this.renderPlaylistItem({
        metadata: item.metadata,
        selected: index === this.props.playlistIndex,
        index: index,
        artwork: this.props.artwork,
        localization: this.props.player.locale
      });
    }).join('');

    this.updateTitle();
    this.updateNextPrevButtons();
    this.resetSearch();
    // this.updateLoadMore();
  }

  appendPlaylist (playlist, startIndex) {
    this.props.playlist = this.props.player.getPlaylist();

    const playlistItemsHtml = playlist.slice(startIndex).map((item, index) => {
      return this.renderPlaylistItem({
        metadata: item.metadata,
        selected: startIndex + index === this.props.playlistIndex,
        index: startIndex + index,
        artwork: this.props.artwork,
        localization: this.props.player.locale
      });
    }).join('');

    this.$('.iono-playlist-items').insertAdjacentHTML('beforeend', playlistItemsHtml);

    this.resetSearch();
    this.updateNextPrevButtons();
    this.updateLoadMore();
  }

  updateTitle () {
    const metadata = this.props.player.getPlaylistMetadata();
    const metadataTitle = metadata.title || this.props.locale.lang('playlist.title');

    if (this.$title) {
      this.$title.textContent = metadataTitle;
    }
  }

  filterPlaylist (term) {
    if (term === '') {
      return this.resetSearch();
    }

    this.props.term = term.toLowerCase();
    this.props.playlist.forEach((item, index) => {
      const matched = item.metadata.title.toLowerCase().indexOf(this.props.term);
      if (matched === -1) {
        this.$(`.iono-playlist-item[data-index="${index}"]`).setAttribute('hidden', true);
      } else {
        this.$(`.iono-playlist-item[data-index="${index}"]`).removeAttribute('hidden');
      }
    });

    this.updateLoadMore();
  }

  resetSearch () {
    this.props.term = '';
    this.$searchInput.value = '';
    this.$$('.iono-playlist-item[hidden]').forEach(item => {
      item.removeAttribute('hidden');
    });

    this.updateLoadMore();
  }

  /**
   * Update the load more ui
   */
  updateLoadMore () {
    if (!this.$loadMore) return;

    if (!this.props.player.canLoadMore()) {
      this.$loadMore.setAttribute('hidden', true);
      return;
    }

    if (this.props.term) {
      this.$loadMore.setAttribute('hidden', true);
    } else {
      this.$loadMore.removeAttribute('hidden');
    }

    if (this.props.loading) {
      this.$loadMore.setAttribute('disabled', true);
      this.$loadMore.querySelector('.iono-icon').removeAttribute('hidden');
    } else {
      this.$loadMore.removeAttribute('disabled');
      this.$loadMore.querySelector('.iono-icon').setAttribute('hidden', true);
    }
  }

  /**
   * Update the selected playlist item
   *
   * @param {Number} index
   */
  updatePlaylistIndex (index) {
    this.props.playlistIndex = index;

    const previous = $('.iono-playlist-item.iono-active', this.$element);
    if (previous) {
      previous.classList.remove('iono-active');
    }

    const current = $(`.iono-playlist-item[data-index="${index}"]`, this.$element);
    if (current) {
      current.classList.add('iono-active');
    }

    this.updateNextPrevButtons();
  }

  /**
   * Update an individual playlist item
   *
   * @param  {number} index The index of the playlist item to update
   */
  updatePlaylistItem (index) {
    const current = this.$('.iono-playlist-items').children[index];

    if (!current) return;

    const item = this.props.playlist[index];

    current.outerHTML = this.renderPlaylistItem({
      metadata: item.metadata,
      selected: index === this.props.playlistIndex,
      index: index,
      artwork: this.props.artwork,
      localization: this.props.player.locale
    });
  }

  /**
   * Update the next / previous buttons
   */
  updateNextPrevButtons () {
    const playlistIndex = this.props.playlistIndex;
    const playlistLen = this.props.playlist.length;

    if (this.$previous) {
      toggleHidden(this.$previous, playlistLen <= 0);
      enableAttribute(this.$previous, 'disabled', playlistIndex <= 0);
    }

    if (this.$next) {
      toggleHidden(this.$next, playlistLen <= 0);
      enableAttribute(this.$next, 'disabled', playlistIndex >= (playlistLen - 1));
    }
  }

  /**
   * Attach component to the DOM
   *
   * @param {Element} element
   */
  attach (element) {
    super.attach(element);

    this.$next = this.$('[data-action="next"]');
    this.$previous = this.$('[data-action="previous"]');
    this.$loadMore = this.$('[data-action="load-more"]');
    this.$search = this.$('.iono-playlist-search');
    this.$title = this.$('.iono-playlist-header .iono-metadata-title');
    this.$subtitle = this.$('.iono-playlist-header .iono-metadata-subtitle');

    if (this.$loadMore) {
      const callback = entries => {
        if (this.props.term === '') {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.loadMore();
            }
          });
        }
      };

      const options = {
        root: this.$loadMore.parentNode,
        rootMargin: '100px',
        threshold: 0.0
      };

      this.loadMoreObserver = new IntersectionObserver(callback, options);
      this.loadMoreObserver.observe(this.$loadMore);
    }

    if (this.$search) {
      this.$searchInput = this.$('.iono-playlist-search-input');
      this.$searchInput.addEventListener('input', this.onsearchinput);
    }

    resizeObserver.observe(this.$element);

    this.$element.addEventListener('click', this.onactionclick);
    this.$element.addEventListener('click', this.onitemclick);
    this.$element.addEventListener('resize', this.onresize);

    $('.iono-button', this.$search).addEventListener('click', this.onsearchfocus);
    this.$search.addEventListener('focus', this.onsearchfocus);

    this.props.player.on('playlistload', this.onplaylistload);
    this.props.player.on('playlistselect', this.onplaylistselect);
    this.props.player.on('playlistchange', this.onplaylistchange);

    this.updateNextPrevButtons();
  }

  /**
   * Detach component from the DOM
   *
   * @param {Element} element
   */
  detach (element) {
    if (this.$element) {
      if (this.$search) {
        this.$searchInput.removeEventListener('input', this.onsearchinput);
      }

      if (this.loadMoreObserver) {
        this.loadMoreObserver.unobserve(this.$loadMore);
        this.loadMoreObserver.disconnect();
        this.loadMoreObserver = null;
      }

      this.$next = null;
      this.$previous = null;
      this.$loadMore = null;
      this.$title = null;
      this.$subtitle = null;
      this.$search = null;
      this.$searchInput = null;

      resizeObserver.unobserve(this.$element);

      this.$element.removeEventListener('click', this.onactionclick);
      this.$element.removeEventListener('click', this.onitemclick);
      this.$element.removeEventListener('resize', this.onresize);
      $('.iono-button', this.$search).removeEventListener('click', this.onsearchfocus);
      this.$search.removeEventListener('focus', this.onsearchfocus);
    }

    super.detach(element);

    this.props.player.off('playlistload', this.onplaylistload);
    this.props.player.off('playlistselect', this.onplaylistselect);
    this.props.player.off('playlistchange', this.onplaylistchange);
  }

  render () {
    const metadata = this.props.player.getPlaylistMetadata() || {};
    const canLoadMore = this.props.player.canLoadMore();

    return `
      <div class="iono-playlist">
        <div class="iono-playlist-header">
          <div class="iono-playlist-title">${metadata.title || this.locale.lang('playlist.title')}</div>
          <div class="iono-playlist-actions iono-button-group">
            <div class="iono-playlist-search" tabindex="0">
              <input type="text" class="iono-playlist-search-input" placeholder="${this.locale.lang('playlist.filter')}" />
              <button type="button" class="iono-button" tabindex="-1" title="${this.locale.lang('playlist.filter')}">${iconFilter}</button>
            </div>
            <button type="button" class="iono-button" title="${this.locale.lang('playlist.previous')}" data-action="previous" disabled>${iconPrevious}</button>
            <button type="button" class="iono-button" title="${this.locale.lang('playlist.next')}" data-action="next" disabled>${iconNext}</button>
          </div>
        </div>

        <div class="iono-scrollable iono-flex-fill" tabindex="-1">
          <ol class="iono-playlist-items"></ol>

          <button class="iono-button iono-playlist-load-more" data-action="load-more" type="button"${canLoadMore ? '' : ' hidden'}>
            <span class="iono-icon iono-button-icon iono-spin iono-margin-right" hidden aria-hidden="true">${iconSpinner}</span>
            ${this.locale.lang('playlist.load_more')}
          </button>
        </div>
      </div>
    `;
  }

  renderPlaylistItem (playlistItemData) {
    const title = metadataTitle(playlistItemData.metadata, this.locale);
    const subtitle = metadataSubTitle(playlistItemData.metadata, this.locale);

    return `
      <li class="iono-playlist-item${playlistItemData.selected ? ' iono-active' : ''}" tabindex="0" data-index="${playlistItemData.index}">
        <div class="iono-metadata">
          <div class="iono-metadata-title iono-ellipsis">${title}</div>
          <div class="iono-metadata-subtitle">${subtitle}</div>
        </div>
        <div class="iono-duration">${iono.Player.formatSeconds(playlistItemData.metadata.duration)}</div>
      </li>
    `;
  }

  onitemclick (event) {
    event.preventDefault();

    const index = parseInt(event.delegateTarget.dataset.index, 10);

    if (index !== this.props.player.getPlaylistIndex()) {
      this.props.player.selectPlaylistItem(index);
      this.props.player.play();
    }
  }

  onactionclick (event) {
    let index, $playlistItem;

    switch (event.delegateTarget.dataset.action) {
      case 'load-more':
        event.preventDefault();
        this.loadMore();
        return;
      case 'search-clear':
        event.preventDefault();
        this.resetSearch();
        return;
      case 'next':
        event.preventDefault();
        this.props.player.nextPlaylistItem();

        index = this.props.player.getPlaylistIndex();
        $playlistItem = this.$(`.iono-playlist-item[data-index="${index}"]`);

        if ($playlistItem) scrollIntoView($playlistItem);
        return;
      case 'previous':
        event.preventDefault();
        this.props.player.previousPlaylistItem();

        index = this.props.player.getPlaylistIndex();
        $playlistItem = this.$(`.iono-playlist-item[data-index="${index}"]`);

        if ($playlistItem) scrollIntoView($playlistItem);
    }
  }
}
